"use client";

import React from "react";
import { motion } from "framer-motion";
export default function ServicePhilosophyBanner() {
  return;
}